export default "__VITE_ASSET__CHyYBX2B__"